var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value > 0)?_c('img',{staticClass:"icon",attrs:{"src":require("assets/operate/up.png"),"alt":""}}):(_vm.value < 0)?_c('img',{staticClass:"icon",attrs:{"src":require("assets/operate/down.png"),"alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }